// ==============================|| OVERRIDES - DIALOG TITLE ||============================== //

export default function DialogTitle() {
  return {
    MuiDialogTitle: {
      defaultProps: {
        sx: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        },
        variant: 'h5'
      },
      styleOverrides: {
        root: {
          padding: '10px 20px'
        }
      }
    }
  };
}
